// REPORTE DE ERRORES (Sentry).
//
// Antes esto era Bugsnag, comentado en index.js con un `getEnvironment()` que no existía y un
// `const ErrorBoundary` que se reasignaba: descomentarlo habría tirado la app entera en el
// arranque. Se rehízo de cero el 5-10-2026, cuando el dueño pidió poder ver los problemas de los
// clientes sin depender de que escriban.
//
// Se prende SOLO en builds de producción (`npm start` local no reporta). Para apagarlo sin tocar
// código: REACT_APP_SENTRY_ENABLED=false en el spec de App Platform → rebuild.
import * as Sentry from "@sentry/react";

const DSN = process.env.REACT_APP_SENTRY_DSN
  || "https://17a9a59e3d027e57c9326050b55c4918@o4512203464441856.ingest.us.sentry.io/4512203505336320";

// Apagado explícito gana sobre todo lo demás; si no, va en cualquier build de producción.
const apagado = String(process.env.REACT_APP_SENTRY_ENABLED || "").toLowerCase() === "false";
const esProduccion = process.env.NODE_ENV === "production";

/** prod / qa / otro: separa en el tablero los errores reales de los de las pruebas. */
function entorno() {
  const h = typeof window !== "undefined" ? window.location.hostname : "";
  if (h === "alumnos.micuenta.blue" || h === "micuenta.blue") return "produccion";
  if (h.includes("qa") || h.includes("ondigitalocean.app")) return "qa";
  return h || "desconocido";
}

export const sentryActivo = Boolean(DSN) && esProduccion && !apagado;

if (sentryActivo) {
  Sentry.init({
    dsn: DSN,
    environment: entorno(),
    integrations: [
      Sentry.replayIntegration({
        // 🔒 MCB muestra datos de personas: nombres de alumnos, DNI, deudas. El replay se guarda
        // enmascarado — se ve QUÉ apretó el cliente, no sus datos.
        maskAllText: true,
        maskAllInputs: true,
        blockAllMedia: true,
      }),
    ],
    // El plan gratis trae poca cuota: no se graba la navegación de todo el mundo, sólo la de las
    // sesiones que terminaron en error, que son las únicas que sirven para entender el problema.
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    tracesSampleRate: 0,   // Tracing apagado (no se contrató)
    sendDefaultPii: false,
    // Ruido conocido del navegador: no son errores de la aplicación y se comen la cuota.
    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "ResizeObserver loop completed with undelivered notifications",
      "Non-Error promise rejection captured",
      /^Network request failed$/,
      /Failed to fetch/,
      "AbortError",
    ],
    denyUrls: [/extensions\//i, /^chrome:\/\//i, /^moz-extension:\/\//i],
  });
}

export default Sentry;
